import Vue from 'vue'
import App from '@/App'
import router from '@/router' // api: https://github.com/vuejs/vue-router
import store from '@/store' // api: https://github.com/vuejs/vuex
import ElementUI from 'element-ui'
import '@/icons' // api: http://www.iconfont.cn/
import '@/assets/scss/index.scss'
import '@/assets/global.scss'
import VueLazyload from 'vue-lazyload'

import VueClipboard from 'vue-clipboard2'

import util from './util'
import './permission'
import * as allAPI from './util/api'

import consts from './util/const.js'

import * as filters from './filters/index.js'
import Base64 from 'js-base64'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Vue.use(Base64)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.use(VueLazyload, {
  // 设置默认显示的图片
  loading: require('./assets/img/loading.gif'),
  error: require('./assets/img/error.jpg')
})

Vue.config.productionTip = false
require('promise.prototype.finally').shim()
Vue.prototype.$http = allAPI
Vue.prototype.$util = util
Vue.prototype.$const = consts

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

function initVue () {
  return new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount('#app')
}

let vueInst = initVue()

if (window && !window.vue) {
  window.vue = vueInst
}
export default vue
